<h1 mat-dialog-title class="editHeader text-center blueHeader dialogHeader text-white">Update Max Doctor</h1>
<mat-dialog-content class="mb-4">
  <div class="row mt-3 col-md-12">
    <div class="col-md-12 mb-1">
      <label for="activeDoctor" class="payingClinic col-md-6 required">Max Active Doctors</label>
      <input type="text" numbersOnly class="form-control input-font name inputBox col-md-6" id="activeDoctor"
        (keyup)="changeMaxDoctor()" [(ngModel)]="activeDoctor">
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="row col-md-12 justify-content-md-center">
    <button mat-button class="mat-raised-button btnWidth  mr-4 btn blankTurquoise"
      (click)="dialogRef.close(false)">Cancel</button>
    <button mat-button class="mat-raised-button btn turquoiseBtn btnWidth btn-sm updateButton" (click)="updateCount()"
      [disabled]="disableButton ? null : true">Update</button>

  </div>
</mat-dialog-actions>
